import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { FileText, ShieldAlert, ShieldCheck } from "lucide-react";

export default function Prescriptions() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/prescriptions").then((r) => setItems(r.data)); }, []);

  return (
    <div className="container-optia py-10 animate-fade-in max-w-3xl">
      <h1 className="font-display text-2xl font-semibold text-navy-900">Minhas prescrições</h1>
      <p className="text-slate-600 mt-1 text-sm">Prescrições emitidas pelos profissionais.</p>

      <div className="mt-6 space-y-4">
        {items.length === 0 && <p className="text-slate-500">Você ainda não tem prescrições.</p>}
        {items.map((p) => (
          <Card key={p.id} className="card-soft" data-testid={`patient-presc-${p.id}`}>
            <CardContent className="p-6">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="flex items-center gap-2">
                    <FileText className="w-4 h-4 text-teal-600" />
                    <div className="font-medium text-navy-900">{p.professional_name}</div>
                  </div>
                  <div className="text-xs text-slate-500 mt-1">{new Date(p.created_at).toLocaleString("pt-BR")}</div>
                </div>
                <span className={`text-xs px-2 py-1 rounded-full flex items-center gap-1 ${p.status === "signed" ? "bg-teal-100 text-teal-800" : "bg-amber-100 text-amber-800"}`}>
                  {p.status === "signed" ? <><ShieldCheck className="w-3 h-3" />Assinada</> : <><ShieldAlert className="w-3 h-3" />Rascunho</>}
                </span>
              </div>
              <ul className="mt-3 list-disc pl-5 text-sm text-slate-800">
                {p.medications.map((m, i) => <li key={`${p.id}-${m.name}-${i}`}><b>{m.name}</b> — {m.dosage}{m.frequency ? ` · ${m.frequency}` : ""}{m.duration ? ` · ${m.duration}` : ""}{m.notes ? ` — ${m.notes}` : ""}</li>)}
              </ul>
              {p.cid_codes?.length > 0 && <div className="text-xs text-slate-600 mt-2">CID: {p.cid_codes.join(", ")}</div>}
              {p.clinical_notes && <div className="text-sm text-slate-700 mt-2">{p.clinical_notes}</div>}
              {p.status !== "signed" && (
                <div className="mt-3 text-xs bg-amber-50 text-amber-900 rounded-lg p-2 border border-amber-200">
                  ⚠️ Rascunho — pendente de assinatura digital ICP-Brasil. Sem validade legal como receita até assinatura via Memed.
                </div>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
